import { IMenu } from '@interfaces/IMenu';
import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
const { persistAtom } = recoilPersist();

export const sidebarIsOpen = atom<boolean>({
  key: 'Common/sidebarIsOpen',
  default: false,
});

export const sidebarIsExpand = atom<boolean>({
  key: 'Common/sidebarIsExpand',
  default: true,
});

export const sidebarIsHovered = atom<boolean>({
  key: 'Common/sidebarIsHovered',
  default: false,
});

export const sidebarScrollPosition = atom<number>({
  key: 'sidebarScrollPosition',
  default: 0,
  effects_UNSTABLE: [persistAtom],
});

export const appMenu = atom<IMenu[]>({
  key: 'Common/appMenu-v2',
  default: [],
  effects_UNSTABLE: [persistAtom],
});

export const appDeviceId = atom<{ device_id: string }>({
  key: 'Common/appDeviceId',
  default: { device_id: '' },
  effects_UNSTABLE: [persistAtom],
});
